import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ClarityModule, ClrInputModule, ClrLayoutModule } from '@clr/angular';
import { OwlDateTimeIntl, OwlDateTimeModule, OWL_DATE_TIME_FORMATS, OWL_DATE_TIME_LOCALE } from '@danielmoncada/angular-datetime-picker';
import { DefaultIntl } from '../../class/defaultintl';
import { OwlMomentDateTimeModule } from '@danielmoncada/angular-datetime-picker-moment-adapter';
import moment from 'moment';
import 'moment/locale/it';

moment.locale('it');
//console.log(moment.locale());

export const MY_MOMENT_FORMATS = { // Necessary for correctly display the date and time in the input field
  parseInput: 'L LT',
  fullPickerInput: 'L LT',
  datePickerInput: 'L',
  timePickerInput: 'LT',
  monthYearLabel: 'MMM YYYY',
  dateA11yLabel: 'LL',
  monthYearA11yLabel: 'MMMM YYYY',
};


@NgModule({
  declarations: [],
  imports: [
    ClarityModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    RouterModule,
    OwlDateTimeModule,
    /*OwlNativeDateTimeModule,*/
    OwlMomentDateTimeModule,
    ClrInputModule,
    ClrLayoutModule
  ],
  exports:[
    ClarityModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    RouterModule,
    OwlDateTimeModule,
    /*OwlNativeDateTimeModule,*/
    OwlMomentDateTimeModule,
    ClrInputModule,
    ClrLayoutModule
  ],
  providers: [
    {provide: OwlDateTimeIntl, useClass: DefaultIntl},
    { provide: OWL_DATE_TIME_FORMATS, useValue: MY_MOMENT_FORMATS },
  ]
})
export class SharedModule { }
